"use strict";

exports.__esModule = true;
exports["default"] = exports.TestTooltip = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  active: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  content: _propTypes["default"].node,
  href: _propTypes["default"].string,
  id: _propTypes["default"].string,
  info: _propTypes["default"].bool,
  noUnderline: _propTypes["default"].bool,
  placement: _propTypes["default"].oneOf(['top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left']),
  size: _propTypes["default"].oneOf(['small', 'large']),
  tabIndex: _propTypes["default"].string,
  theme: _propTypes["default"].oneOf(['light', 'dark'])
};
var defaultProps = {
  active: false,
  children: '',
  info: false,
  noUnderline: false,
  placement: 'top-center',
  tabIndex: '0',
  theme: 'light'
};

var Tooltip = function Tooltip(_ref) {
  var _classNames;

  var active = _ref.active,
      placement = _ref.placement,
      children = _ref.children,
      content = _ref.content,
      theme = _ref.theme,
      size = _ref.size,
      info = _ref.info,
      className = _ref.className,
      id = _ref.id,
      href = _ref.href,
      noUnderline = _ref.noUnderline,
      tabIndex = _ref.tabIndex,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["active", "placement", "children", "content", "theme", "size", "info", "className", "id", "href", "noUnderline", "tabIndex"]);

  var triggerClasses = (0, _classnames["default"])('grv-tooltip__trigger', {
    'grv-tooltip__info-icon': info,
    'grv-tooltip__trigger--no-underline': noUnderline
  }, className);
  var tooltipClasses = (0, _classnames["default"])('grv-tooltip', "grv-tooltip--" + theme, "grv-tooltip--" + placement, (_classNames = {}, _classNames["grv-tooltip--" + size] = size, _classNames), {
    'grv-tooltip--active': active
  });

  var childrenAndContent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, /*#__PURE__*/_react["default"].createElement("span", _extends({}, otherProps, {
    className: tooltipClasses,
    id: id
  }), content));

  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      "aria-labelledby": id,
      role: "button",
      className: triggerClasses,
      href: href
    }, childrenAndContent);
  }

  return /*#__PURE__*/_react["default"].createElement("span", {
    "aria-labelledby": id,
    role: "button",
    className: triggerClasses,
    tabIndex: parseInt(tabIndex)
  }, childrenAndContent);
};

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
var TestTooltip = Tooltip;
exports.TestTooltip = TestTooltip;

var _default = (0, _withId["default"])(Tooltip);

exports["default"] = _default;